
























import { authSym } from '@/layouts/PageLayout.vue';
import { defineComponent, inject } from '@vue/composition-api';
export default defineComponent({
  components: {
    AppBarAuthMenu: () => import('@/components/partial/AppBarAuthMenu.vue'),
    AppBarMenu: () => import('@/components/partial/AppBarMenu.vue'),
  },
});
